<template lang="pug">
section
  header.d-flex.row.flex-row.align-items-end.mb-3
    .col-8
      h1.m-0
        i Dashboard
    .col-4.text-right
      //- router-link.btn.btn-secondary.py-2.px-4(to="create")
      //-   i.icon.icon-plus.icon--1x.mr-2
      //-   strong Nuevo usuario
  section
    .d-flex.flex-row.align-items-start.mt-4.ad_border1-secondary.rounded-xl.py-1.w-50.ml-auto
      .col
        b-form-input.border-0(v-model='filter', placeholder='Buscar por nombre, usuario, perfil, e-mail o rut')
      .col-auto
        b-button.py-1(:disabled='!filter', @click="filter = ''", title='Limpiar filtro')
          i.icon.icon--1x.icon-cross

    .d-flex.row.flex-row.align-items-start.mt-4
      .col-12
        .card.p-0.ad_bg-gray.rounded-xl
          .card-body
            b-table.table-simple.no-border(
              show-empty
              stacked="md"
              :items='users',
              :fields="fields",
              :current-page="0",
              :per-page="perPage",
              :filter="filter",
              @filtered="onFiltered")
              template(slot='history', slot-scope='row')
                router-link(:to="{path:'/consultor-externo-historico/'+row.item.id}" title="Historial" append)
                  i.icon.icon-file-stats2
              template(slot='lsessions', slot-scope='row')
                //- .div(v-if="row.sessions")
                .sessions-list
                  div(v-for="(s, index) in row.item.sessions")
                    i.icon-letters.icon-letters__viaje.mr-2(@click="showModal(row.item, s, true)")
              template(slot='newsession', slot-scope='row')
                i.icon-letters.icon-letters__producto.mr-2(@click="showModal(row.item, null, false)")
            .row.mt-5
              .col-auto
                p Total de Kpi Adherencia:
                  |  {{ totalRows }}
              .col-auto.ml-auto
                .ad_select.px-3
                  select(v-model='perPage', @change="changePerPage()")
                    option(:value="null" disabled selected) Items
                    option(:value="numero", v-for="numero in itemsPerPAge") {{numero}}
              .col-auto.ml-auto
                //- sliding-pagination(
                //-   :current="currentPage"
                //-   :total="totalPages"
                //-   @page-change="pageChangeHandler")
                b-pagination(
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0",
                  @change="pageChangeHandler")

  b-modal(:id='sessionModal.id', :title='sessionModal.title', centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
    <template v-slot:modal-title>
      h3.font-weight-bold.mb-0 {{ currentSessionName ?  currentSessionName : `Sesion N॰ ${sessionsThisYear + 1}` }} {{ currentUser ? currentUser.name : ''}}
    </template>
      section.modal-body-session(style="overflow: auto; max-height: 100vh;")
        slot(name="body")
          .row
            .col-8
              span.h4.font-italic Kpi
            .col-2
            
            .col-2
              span foco
          .row(v-for="k in currentKpis")
            .col-8
              .d-flex.row.form-group.align-items-end.mb-1
                .col
                  a()
                    i.icon-letters.icon-letters__viaje.mr-2 V
                  b-tooltip(placement='top')
                    | 
                  a()
                  | {{k.name}}
                .col-auto
                  p.d-inline-block.mb-0.ad_text-grayMedio
                    sup Meta
                    span {{k.goal}} %
            .col-2
              .input-refresh.d-flex.flex-row.align-items-center.ml-2
                input(v-model="k.value", type="text", label='%', max='100', maxlength='3', :disabled="onlyvisual")
                | %
            .col-2
              input.form-checkbox.text-none(v-model="k.is_focused", type="checkbox", label="", :disabled="onlyvisual")
          hr.my-4
          .row
            .col-4
              span Competencias
            .col-4
              span Conductas
            .col-2
              span Evaluacion
            .col-2
          div(v-for="category in currentEvaluations")
            div(v-for="e in category.evaluations")
              .row
                .col-4
                  span {{category.category.name}}
                .col-4
                  span {{e.evaluation}} 
                .col-2
                  .ad_select
                    select(v-model="e.result_name", :disabled="onlyvisual")
                      option(:value="null" selected) 
                      option(:value="s", v-for="s in curentScaleValues", :key="s._id") {{s.name}}
                .col-2
                  input.form-checkbox.text-none(v-model="e.is_focused", type="checkbox", label="", :disabled="onlyvisual")
          hr.my-4
          .row
            .col-2
              small.d-block {{minute.date_created | DateFormat}}
            .col-10
              .dialog-box
                textarea.form-control(v-model="minute.text", rows="10", placeholder='ingresa minuta', title='Minuta', :disabled="onlyvisual")
                .col-auto.form-group.align-items-center.mb-0.pr-0
          .row(v-for="l in currentLastSessions.docs")
            .col-2
              small.d-block {{l.minutes.date_created | DateFormat}}
            .col-10
              .dialog-box
                textarea.form-control(v-model="l.minutes.text", rows="10", placeholder='', title='Minuta', disabled)
                .col-auto.form-group.align-items-center.mb-0.pr-0
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      .col-12.d-flex.justify-content-around
        b-button.px-4(size="lg", variant="danger", @click="$bvModal.hide(sessionModal.id)")
          | Cancelar
        b-button.px-4(v-if="onlyvisual", size="lg", variant="info", @click="activateModal()")
          | Editar
        b-button.px-4(v-if="!editForm", size="lg", variant="success", @click="addSession()")
          | Guardar
        b-button.px-4(v-if="editForm", size="lg", variant="success", @click="updateASession()")
          | Guardar
    </template>

  b-modal(:id='infoModal.id', :title='infoModal.title', modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
    p {{ infoModal.content }}
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      .col-12.d-flex.justify-content-around
        b-button.px-4(size="lg", variant="success", @click="$bvModal.hide(infoModal.id)")
          | Ok
    </template>
  b-modal(:id='reopenModal.id', :title='reopenModal.title', centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
    p {{ reopenModal.content }}
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      .col-12.d-flex.justify-content-around
        b-button.px-4(size="lg", variant="danger", @click="$bvModal.hide(reopenModal.id)")
          | No
        b-button.px-4(size="lg", variant="success", @click="Reabrir()")
          | Reabrir
    </template>   
</template>

<script>
import { mapActions } from 'vuex'
import administracionUsuariosDetailVue from '../administracion-usuarios-detail.vue';
import Modal from './modals/modal-session.vue';
import moment from 'moment';

export default {
  name: 'DashboardSessions',
  components: {
    Modal,
  },
  data () {
    return {
      user: null,
      users: null,
      filter: null,
      totalRows: 1,
      totalPages: 0,
      currentPage: 1,
      perPage: 5,
      fields: [
        { key: 'rut', label: 'Rut', sortable: true},
        { key: 'name', label: 'Nombre', sortable: true, sortDirection: 'desc'},
        { key: 'email', label: 'Email', sortable: true},
        { key: 'history', label: 'Historial' , class: 'text-right'},
        { key: 'lsessions', label: 'Sesiones' , class: 'fix-size-td__lg'},
        { key: 'newsession', label: ' ' , class: 'text-right'}
      ],
      sessionModal: {
        id: 'session-modal',
        title: '',
        content: '',
        buttonName: '',
        action: ''
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
        buttonName: '',
        action: ''
      },
      reopenModal: {
        id: 'reopen-modal',
        title: 'Reabrir Planificacion',
        content: ''
      },
      isModalVisible: false,
      editForm: false,
      currentUser: null,
      currentEvaluations: null,
      curentScaleValues: [],
      currentLastSessions: [],
      currentKpis: [],
      currentYear: moment().get('year'),
      currentPeriod: (moment().get('month') + 1),
      sessionsThisYear: 0,
      currentSessionName: null,
      minute: {text: null, date_created: moment()},
      onlyvisual: false,
      itemsPerPAge: [5,10,15],
      search: '',
      sort: [],
      currentIdSession: null
    }
  },
  methods: {
    ...mapActions('user', [
      'getUsers',
      'activateUser',
      'myTeam',
      'getKpiextByUserId'
    ]),
    ...mapActions('plan', [
      'reopenCurrentWeekPlan'
    ]),
    ...mapActions("session", ["getMyTeamSessions","sessionsByYear", "createSession", "updateCurrentPage","updateSession"]),
    ...mapActions("consultant", ["getEvaluationQuestionsByCategory"]),
    ...mapActions("scalevalues", ["scaleValuesList", "getLastMinutesByUserEvaluated"]),
    onlyUsersActives(items) {
      return items.filter(u => u.isDeleted === false)
    },
    getItemsToMultiSelectLoad(items) {
      return items.map(p => ({value: p.id, label: p.name, profile: p.profilename, leader: p.leader}))
    },
    pageChangeHandler(selectedPage) {
      const vm = this
      vm.currentPage = selectedPage;
      vm.updateCurrentPage(selectedPage).then(() => {
        vm.loadLeaders();
      })
    },
    changePerPage(){
      const vm = this
      vm.currentPage = 1
      vm.updateCurrentPage(1).then(() => {
        vm.loadLeaders();
      })
    },
    onFiltered(filteredItems) {
      this.totalRows = this.onlyUsersActives(filteredItems).length
      this.currentPage = 1
    },
    deleteUser(item, index, button, action) {
      const vm = this
      let name = item.username ? item.username : item.name;
      let actionName = action ? 'Eliminar' : 'Activar';
      vm.$root.$emit('bv::show::modal', vm.infoModal.id, button)
      const modal = vm.$el.querySelector('.modal')
      modal.style.left = '25%'
      modal.style.right = '25%'
      modal.style.top = '25%'
      modal.style.height = '240px'
      vm.infoModal.title = `${actionName} usuario`
      vm.infoModal.content = `¿Está seguro de ${actionName} el usuario "${name}"?`
      vm.infoModal.userId = item.id
      vm.infoModal.buttonName = actionName
      vm.infoModal.action = action
    },
    handleOk() {
      const vm = this
      const data = {id: vm.infoModal.userId, isDeleted: vm.infoModal.action}
      vm.activateUser(data).then(user => {
        vm.$bvModal.hide(vm.infoModal.id)
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'Usuario eliminado',
          closeable: true,
          duration: 5000
        })
        vm.listUsers()
      }).catch(e => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: e.payload.message.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    modalReopenPlan(item, index, button) {
      const vm = this
      vm.$root.$emit('bv::show::modal', vm.reopenModal.id, button)
      const modal = vm.$el.querySelector('.modal')
      modal.style.left = '25%'
      modal.style.right = '25%'
      modal.style.top = '25%'
      modal.style.height = '240px'
      vm.reopenModal.content = `¿Está seguro de reabrir el plan de la semana actual del usuario "${item.username}"?`
      vm.reopenModal.userId = item.id
    },
    Reabrir() {
      const vm = this
      const data = {user: vm.reopenModal.userId}
      vm.reopenCurrentWeekPlan(data).then( result => {
        vm.$bvModal.hide(vm.reopenModal.id)
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'Plan Semanal Abierto',
          closeable: true,
          duration: 5000
        })
      }).catch(e => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: e.payload.message.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    loadLeaders() {
      const vm = this;
      console.log("vm.currentPage");
      console.log(vm.currentPage);
      vm.getMyTeamSessions({
        year: vm.currentYear,
        pagination: {page: vm.currentPage, perPage: vm.perPage}, 
        sort: vm.sort, 
        search: vm.search
      }).then(response => {
        vm.users = response.message.docs;
        vm.totalRows = response.message.total;
        vm.totalPages =  response.message.totalPages
        console.log("totalPages");
        console.log(vm.totalPages);
      });
    },
    showModal(row, session, onlyvisual) {
      const loading = this.$toast.loading('Abriendo...')
      this.getUserKpiExt(row.id).then(() => {
        let filter = {id: row.id, pagination: {page: 1, perPage: 3}};
        if (onlyvisual) {
          filter.sessionid = session._id;
          this.currentIdSession = session._id;
        }
        this.getLastMinutes(filter).then(() => {
          this.$root.$emit('bv::show::modal', this.sessionModal.id)
          const modalboy = this.$el.querySelector('.modal-body');
          const modalcontent = this.$el.querySelector('.modal-content');
          modalboy.style.width = '700px';
          modalcontent.style.width = '700px';
          if (onlyvisual) {
            
            for (let sg of session.guideline_values) {
              for (let indexce in this.currentEvaluations) {
                if (sg.categoryext_id == this.currentEvaluations[indexce].category._id) {
                  for (let index in this.currentEvaluations[indexce].evaluations) {
                    if (this.currentEvaluations[indexce].evaluations[index].evaluation == sg.guideline_name) {
                      this.currentEvaluations[indexce].evaluations[index].is_focused = sg.is_focused;
                      for (let sv of this.curentScaleValues ) {
                        if (sv.name == sg.result_name) {
                          this.currentEvaluations[indexce].evaluations[index].result_name = sv;
                          break;
                        }
                      }
                      break;
                    }
                  }
                  break;
                }
              }
            }
            // this.currentEvaluations = session.guideline_values;
            this.currentKpis = session.kpiext_values;
            if (session) {
              this.minute.text = session.minutes.text;
              this.minute.date_created = session.minutes.date_created;
            }
          } else {
            this.clearForm();
          }
          this.onlyvisual = onlyvisual;
          this.currentUser = row;
          for (let u of this.users) {
            if (u._id == row._id) {
              this.sessionsThisYear = u.sessions.length;
            }
          }
          this.currentSessionName = session ? session.name : null;
          loading.hide();
        }, (error) => {
          loading.hide();
          this.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          })
        });
      }, (error) => {
        loading.hide();
        this.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      });
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getEvaluations() {
      const vm = this;
      vm.getEvaluationQuestionsByCategory({}).then(() => {
        vm.currentEvaluations = vm.$store.getters['consultant/getExtGuidelines'];
        for (let index in vm.currentEvaluations) {
          for (let ind in vm.currentEvaluations[index].evaluations) {
            vm.currentEvaluations[index].evaluations[ind].is_focused = false;
            vm.currentEvaluations[index].evaluations[ind].result_name = null;
          }
        }
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      });
    },
    getScaleValues() {
      const vm = this;
      vm.scaleValuesList().then((response) => {
        console.log(response);
        vm.curentScaleValues = response;
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      });
    },
    getLastMinutes(data) {
      return new Promise((resolve, reject) => {
        const vm = this;
        vm.getLastMinutesByUserEvaluated(data).then((response) => {
          vm.currentLastSessions = response;
          resolve();
        }, (error) => {
          reject(error);
        });
      });
    },
    getUserKpiExt(id) {
      return new Promise((resolve, reject) => {
        const vm = this;
        vm.getKpiextByUserId(id).then((response) => {
          for (let index in response) {
            response[index].is_focused = false;
            response[index].value = null;
          }
          vm.currentKpis = response;
          resolve();
        }, (error) => {
          reject(error);
        });
      });
    },
    getSessionsThisYear() {
      const vm = this;
      vm.sessionsByYear().then((numberOfSessions) => {
        vm.sessionsThisYear = numberOfSessions;
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      });
    },
    addSession() {
      const loading = this.$toast.loading('Guardando...')
      this.validateForm().then(() => {
        this.createSession({evaluations: this.currentEvaluations, kpiext: this.currentKpis, minute: this.minute, user: this.user.id, user_evaluated: this.currentUser._id, name: `Sesion N॰ ${ this.sessionsThisYear + 1 }`}).then((doc) => {
          this.$bvModal.hide(this.sessionModal.id);
          this.updateUser(doc);
          loading.hide();
          this.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Sesion creada',
            closeable: true,
            duration: 5000
          })
        }, (error) => {
          loading.hide();
          this.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          });
        });
      }, (error) => {
        loading.hide();
        this.infoModal.content = error;
        this.infoModal.title = '¡Alerta!'
        this.$bvModal.show(this.infoModal.id)
      });
    },
    updateASession() {
      const loading = this.$toast.loading('Guardando...')
      this.validateForm().then(() => {
        this.updateSession({evaluations: this.currentEvaluations, kpiext: this.currentKpis, minute: this.minute, id: this.currentIdSession }).then((doc) => {
          this.$bvModal.hide(this.sessionModal.id);
          loading.hide();
          this.loadLeaders();
          this.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Sesion editada',
            closeable: true,
            duration: 5000
          })
        }, (error) => {
          loading.hide();
          this.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          });
        });
      }, (error) => {
        loading.hide();
        this.infoModal.content = error;
        this.infoModal.title = '¡Alerta!'
        this.$bvModal.show(this.infoModal.id)
      });
    },
    validateForm() {
      return new Promise((resolve, reject) => {
        let error = false;
        let touchEval = false;
        let emptyEval = false;
        let emptyKpi = false;
        let emptyMinute = false;
        let errorKpi = false;
        let errorCon = false;

        if (this.currentEvaluations) {
          for (let obj of this.currentEvaluations) {
            for (let e of obj.evaluations) {
              if (e.result_name !== null) {
                touchEval = true;
                break;
              }
            }
            if (touchEval) {
              for (let e of obj.evaluations) {
                if (e.result_name == null) {
                  emptyEval = true;
                  break;
                }
              }
            }
            if (touchEval && emptyEval) {
              break;
            }
          }
        }

        if (this.currentKpis) {
          for (let k of this.currentKpis) {
            if (k.value == null) {
              emptyKpi = true;
              break;
            }
          }
        } 

        let message = 'Datos faltantes: ';
        if (touchEval && emptyEval) {
          error = true;
          errorCon = true;
          message += 'Conductas '
        }
        if (emptyKpi) {
          error = true;
          errorKpi = true;
          message += errorCon ? ', KPIs': 'KPIs';
        }

        if (this.minute.text == null) {
          
          message += (errorKpi || errorCon) ? ', minuta.' : 'minuta';
        }

        if (error) {
          reject(message);
        } else {
          resolve();
        }
      });
    },
    clearForm() {
      this.minute.text = null;
      this.minute.date_created = moment();
      for (let indexce in this.currentEvaluations) {
        for (let index in this.currentEvaluations[indexce].evaluations) {
          this.currentEvaluations[indexce].evaluations[index].is_focused = false;
          this.currentEvaluations[indexce].evaluations[index].result_name = null;
        }
      }
    },
    updateUser(newsession) {
      const vm = this;
      for (let index in vm.users) {
        if (vm.users[index]._id == newsession.user_evaluated) {
          vm.users[index].sessions.push(newsession);
        }
      }
    },
    activateModal() {
      this.onlyvisual = false;
      this.editForm = true;
    }
  },
  mounted() {
    const vm = this;
    vm.user = vm.$store.state.auth.user;
    vm.loadLeaders();
    vm.getEvaluations();
    vm.getScaleValues();
    // vm.getSessionsThisYear();
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/consultor-externo/consultor-externo-dashboard.vue